<template>
  <b-form-group
    v-if="!dataLoad"
  >
    <b-form-select
      v-model="SourceName"
      :options="optionsSource"
      trim
      @change="handleSource"
    />

  </b-form-group>
</template>

<script>

export default {
  props: {
    dataLoad: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      SourceName: '' || this.$route.query.source,
    }
  },
  computed: {
    optionsSource() {
      return this.$store.getters['generalData/source/source']
    },
  },
  methods: {
    handleSource() {
      this.$router.push({
        query: { ...this.$route.query, source: this.SourceName },
      })
    },
  },
}
</script>
